import React from "react";

const AdminAccessRequestTemplate = ({
  adminName,
  requesterName,
  requesterEmail,
  loginUrl,
}) => {
  const currentYear = new Date().getFullYear();

  const getEmailBody = () => {
    return `
      <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f5f5f5;">
        <tr>
          <td align="center" style="padding: 20px 0;">
            <table width="600" cellpadding="0" cellspacing="0" border="0" style="background-color: #ffffff; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
              <!-- Header -->
              <tr>
                <td style="background-color: #ff6b35; padding: 30px 20px; text-align: center;">
                  <h1 style="margin: 0; font-size: 28px; font-weight: bold; color: #ffffff;">
                    <span style="color: #ffffff;">CRITICAL</span>RIVER
                  </h1>
                  <p style="margin: 10px 0 0 0; color: rgba(255,255,255,0.9); font-size: 14px;">Contract Lifecycle Management</p>
                </td>
              </tr>
              <!-- Body -->
              <tr>
                <td style="padding: 40px 30px; background-color: #ffffff;">
                  <h2 style="margin: 0 0 20px 0; color: #333333; font-size: 20px;">New Access Request</h2>
                  <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">Hi <strong>${adminName}</strong>,</p>
                  <p style="margin: 0 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">
                    <strong>${requesterName}</strong> <a href="mailto:${requesterEmail}" style="color: #ff6b35; text-decoration: none;">${requesterEmail}</a> has requested access to the CLM system.
                  </p>

                  <!-- Alert Box -->
                  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 6px; padding: 16px 20px; margin: 20px 0;">
                    <tr>
                      <td style="padding-right: 12px; font-size: 20px;">Pending</td>
                      <td>
                        <strong style="color: #333333; display: block; margin-bottom: 4px;">Action Required</strong>
                        <p style="margin: 0; color: #666666; font-size: 14px;">Please review and approve this access request.</p>
                      </td>
                    </tr>
                  </table>

                  <!-- CTA Button -->
                  <div style="text-align: center; margin: 30px 0;">
                    <a href="${loginUrl}" style="background-color: #ff6b35; color: white; padding: 14px 32px; font-size: 16px; font-weight: 600; text-decoration: none; border-radius: 50px; display: inline-block; box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);">
                      Approve Access
                    </a>
                  </div>

                  <p style="margin: 20px 0 15px 0; color: #666666; line-height: 1.6; font-size: 15px;">
                    After logging in, go to <strong>Roles → Assign Role</strong> to grant access.
                  </p>

                 
              </tr>
              <!-- Footer -->
              <tr>
                <td style="background-color: #2c3e50; padding: 30px; text-align: center;">
                  <p style="margin: 0 0 10px 0; color: #bbbbbb; font-size: 13px;">&copy; ${currentYear} CriticalRiver. All rights reserved.</p>
                  <p style="margin: 10px 0 0 0; color: #bbbbbb; font-size: 13px;">Automated Access Request Notification</p>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    `;
  };

  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <title>Access Request - Action Required</title>
    </head>
    <body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f5f5f5;">
      ${getEmailBody()}
    </body>
    </html>
  `;
};

export default AdminAccessRequestTemplate;